import configuration from "./configuration";
import { appConfig } from "../config";

import SfLoaderSvg from "../images_new/normal_with_partially_filled/glowing_SVG.svg?react";
import PfIconSvg from "../images_new/PeoplesFans/peoples_fans_icon.svg?react";
import SfSignupPerformerIcon from "../images_new/icon/stripper-girl-only.svg?react";
import SfAboutIllustration from "../images_new/Stripper.svg?react";
import SfF2FLogo from "../images_new/stripperfans-new-logo.svg?react";
import PfF2FLogo from "../images_new/PeoplesFans/peoplesfans-new-logo.svg?react";

const STRIPPERFANS_LOGIN = {
  ipad: "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/login/ipad.png",
  icon: "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/login/Icon.png",
  icon2: "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/login/Icon2.png",
  heart: "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/login/heart.png",
  trophy: "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/login/trophy.svg",
  secured: "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/login/secured.png",
  playNew: "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/login/playNew.png",
  worldwide:
    "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/login/worldwide.png",
  defaultVideo:
    "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/login/defaultVideo.png",
  communityIcon:
    "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/login/communityIcon.png",
  startIncomeIcon:
    "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/login/startIncomeIcon.png",
  onlineIncomeIcon:
    "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/login/onlineIncomeIcon.png",
};

const BRAND_ASSETS = {
  stripperfans: {
    siteName: "StripperFans",
    logoLight:
      "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images_new/logo_light.svg",
    logoDark:
      "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images_new/logo_dark.svg",
    siteIcon: "",
    welcomeLogo:
      "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images_new/LogoLight.png",
    backdropLight:
      "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images_new/icon/stripperfans-backdrop-logo.png",
    backdropDark:
      "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images_new/icon/stripperfans-backdrop-logo-dark.png",
    login: STRIPPERFANS_LOGIN,
    local: {
      loader: "images_new/normal_with_partially_filled/glowing_SVG.svg",
      signupPerformer: "images_new/icon/stripper-girl-only.svg",
      aboutIllustration: "images_new/Stripper.svg",
      f2fLogo: "images_new/stripperfans-new-logo.svg",
    },
  },
  peoplesfans: {
    // TODO: To update these assets with the actual domain assets, currently we use available one's
    siteName: "PeoplesFans",
    logoLight:
      "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images_new/peoplesfans_logo_light.svg",
    logoDark:
      "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images_new/peoplesfans_logo_dark.svg",
    siteIcon: "",
    welcomeLogo:
      "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images_new/peoplesfans_logo_dark.svg",
    backdropLight:
      "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images_new/peoplesfans-backdrop-logo-light_final.png",
    backdropDark:
      "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images_new/peoplesfans-backdrop-logo-dark.png",
    login: {
     
      ...STRIPPERFANS_LOGIN,
      ipad: "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images_new/peoples_fans_login_screen_ipad.png",
      icon: "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images_new/peoplesfans_logo_final.svg",
      icon2: "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images_new/peoplesfans_logo_final.svg",
    },
    local: {
      loader: "images_new/PeoplesFans/peoples_fans_icon.svg",
      signupPerformer: "images_new/PeoplesFans/peoples_fans_icon.svg",
      aboutIllustration: "images_new/PeoplesFans/peoples_fans_icon.svg",
      f2fLogo: "images_new/PeoplesFans/peoples_fans_icon.svg",
    },
  },
};

const FRONTEND_URL_CACHE_KEY = "frontend_url";

const trimUrl = (value = "") => {
  if (typeof value !== "string") return "";
  const trimmed = value.trim();
  return trimmed ? trimmed.replace(/\/+$/, "") : "";
};

// Namespace the cached frontend URL by the current hostname so a value
// persisted while visiting one brand domain can never be returned while
// visiting another. Falls back to the legacy unscoped key off-browser.
const getFrontendUrlCacheKey = () => {
  if (typeof window === "undefined") return FRONTEND_URL_CACHE_KEY;
  const host = window.location?.hostname || "";
  return host ? `${FRONTEND_URL_CACHE_KEY}:${host}` : FRONTEND_URL_CACHE_KEY;
};

export const getFrontendUrl = () => {
  const fromConfig = trimUrl(configuration.get("configData.frontend_url"));
  if (fromConfig) return fromConfig;

  const fromEnv = trimUrl(appConfig.domain);
  if (fromEnv) return fromEnv;

  if (typeof window !== "undefined") {
    try {
      const cached = trimUrl(localStorage.getItem(getFrontendUrlCacheKey()));
      if (cached) return cached;
    } catch (_) {
      // ignore
    }
    return trimUrl(window.location.origin);
  }

  return "";
};

export const getBrandCheckUrl = () => {
  const frontendUrl = getFrontendUrl();
  if (frontendUrl) return frontendUrl;

  const apiHost = trimUrl(appConfig.apiHost);
  if (apiHost) return apiHost;

  return "";
};

export const getContactEmail = () =>
  normalizeAsset(configuration.get("configData.contact_email"));

export const isPeoplesFansDomain = () =>
  /peoplesfans/i.test(getBrandCheckUrl());

export const isBrandingConfigLoaded = () =>
  Boolean(normalizeAsset(configuration.get("configData.frontend_url")));

export const persistBrandFromConfig = (configData) => {
  const frontendUrl = normalizeAsset(configData?.frontend_url);
  if (!frontendUrl || typeof window === "undefined") return;

  try {
    localStorage.setItem(getFrontendUrlCacheKey(), frontendUrl);
  } catch (_) {
    // ignore
  }
};

const getActiveBrand = () =>
  isPeoplesFansDomain() ? BRAND_ASSETS.peoplesfans : BRAND_ASSETS.stripperfans;

const pickBrandUrl = (value, stripperfansFallback) =>
  value || stripperfansFallback;

let lightLogoMemo = { brandKey: "", siteLogoKey: "", value: "" };
let siteNameMemo = { brandKey: "", siteNameKey: "", value: "" };
let siteIconMemo = { brandKey: "", siteIconKey: "", value: "" };

const normalizeAsset = (asset) => {
  if (typeof asset !== "string") return "";
  return asset.trim();
};

export const resetBrandingCache = () => {
  lightLogoMemo = { brandKey: "", siteLogoKey: "", value: "" };
  siteNameMemo = { brandKey: "", siteNameKey: "", value: "" };
  siteIconMemo = { brandKey: "", siteIconKey: "", value: "" };
};

const getBrandKey = () => (isPeoplesFansDomain() ? "peoplesfans" : "stripperfans");

export const getSiteLogo = ({ isDark = false } = {}) => {
  const brand = getActiveBrand();
  const brandKey = getBrandKey();
  const sf = BRAND_ASSETS.stripperfans;
  const siteLogo = normalizeAsset(configuration.get("configData.site_logo"));
  
  if (isDark) {
    return pickBrandUrl(brand.logoDark, sf.logoDark);
  }

  if (
    lightLogoMemo.brandKey === brandKey &&
    lightLogoMemo.siteLogoKey === siteLogo
  ) {
    return lightLogoMemo.value;
  }

  lightLogoMemo = {
    brandKey,
    siteLogoKey: siteLogo,
    value: siteLogo || pickBrandUrl(brand.logoLight, sf.logoLight),
  };

  return lightLogoMemo.value;
};

export const getBackdropLogo = ({ isDark = false } = {}) => {
  const brand = getActiveBrand();
  const sf = BRAND_ASSETS.stripperfans;

  if (isDark) {
    return pickBrandUrl(brand.backdropDark, sf.backdropDark);
  }

  return pickBrandUrl(brand.backdropLight, sf.backdropLight);
};

// Light-colored watermark assets read stronger on dark backgrounds than dark
// watermarks do on light ones. StripperFans PNGs already bake in low alpha, so
// only a slight reduction is needed. PeoplesFans assets are much more opaque.
const BACKDROP_DARK_MODE_OPACITY = {
  stripperfans: 1,
  peoplesfans: 0.25,
};

export const getBackdropLogoStyle = ({ isDark = false, width } = {}) => {
  const style = { height: "auto" };

  if (width) {
    style.width = width;
  }

  if (isDark) {
    const brandKey = isPeoplesFansDomain() ? "peoplesfans" : "stripperfans";
    const opacity = BACKDROP_DARK_MODE_OPACITY[brandKey];

    if (typeof opacity === "number") {
      style.opacity = opacity;
    }

    if (brandKey === "stripperfans") {
      // PNG has ~5% alpha baked in; each zero-offset drop-shadow pass
      // redraws the mask behind it, compounding to a visible watermark.
      style.filter =
        "drop-shadow(0 0 0 #fff) drop-shadow(0 0 0 #fff) drop-shadow(0 0 0 #fff)";
    }
  }

  return style;
};

export const getWelcomeLogo = () => {
  const brand = getActiveBrand();
  return pickBrandUrl(brand.welcomeLogo, BRAND_ASSETS.stripperfans.welcomeLogo);
};

export const getLoginAsset = (assetKey) => {
  const brand = getActiveBrand();
  const sf = BRAND_ASSETS.stripperfans;
  const value = brand.login[assetKey];
  const fallback = sf.login[assetKey];

  return value || fallback || "";
};

export const getLoaderSvgPath = () => {
  const brand = getActiveBrand();
  return brand.local.loader;
};

export const getSignupPerformerIconPath = () => {
  const brand = getActiveBrand();
  return brand.local.signupPerformer;
};

export const getAboutIllustrationPath = () => {
  const brand = getActiveBrand();
  return brand.local.aboutIllustration;
};

export const getF2FLogoPath = () => {
  const brand = getActiveBrand();
  return brand.local.f2fLogo;
};

export const getSiteName = () => {
  const brand = getActiveBrand();
  const brandKey = getBrandKey();
  const siteName = normalizeAsset(configuration.get("configData.site_name"));

  if (siteNameMemo.brandKey === brandKey && siteNameMemo.siteNameKey === siteName) {
    return siteNameMemo.value;
  }

  siteNameMemo = {
    brandKey,
    siteNameKey: siteName,
    value: siteName || brand.siteName,
  };

  return siteNameMemo.value;
};

export const getPageTitle = (suffix) => {
  const siteName = getSiteName();

  if (!suffix) {
    return siteName;
  }

  if (suffix === "!") {
    return `${siteName}!`;
  }

  return `${siteName} - ${suffix}`;
};

export const getSiteIcon = () => {
  const brand = getActiveBrand();
  const brandKey = getBrandKey();
  const siteIcon = normalizeAsset(configuration.get("configData.site_icon"));

  if (siteIconMemo.brandKey === brandKey && siteIconMemo.siteIconKey === siteIcon) {
    return siteIconMemo.value;
  }

  siteIconMemo = {
    brandKey,
    siteIconKey: siteIcon,
    value: siteIcon || brand.siteIcon,
  };

  return siteIconMemo.value;
};

// Kept for backward compatibility if anything imports it directly.
export const BRANDING_ASSETS = {
  login: STRIPPERFANS_LOGIN,
};

export const getLoaderSvgComponent = () =>
  isPeoplesFansDomain() ? PfIconSvg : SfLoaderSvg;

export const getSignupPerformerIconComponent = () =>
  isPeoplesFansDomain() ? PfIconSvg : SfSignupPerformerIcon;

export const getAboutIllustrationComponent = () =>
  isPeoplesFansDomain() ? PfIconSvg : SfAboutIllustration;

export const getF2FLogoComponent = () =>
  isPeoplesFansDomain() ? PfF2FLogo : SfF2FLogo;
